<style scoped lang="scss" type="text/scss">

</style>

<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: '',
        data () {
            return {};
        }
    };
</script>
